import { Flex, forwardRef, Heading, Text } from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { useTranslation } from 'react-i18next';

import { EventCard } from '@/components/ui/shared/event/EventCard/EventCard';
import { queryEventHubCounters } from '@/queries/event-hub-counters';
import { ThinEvent } from '@/resources/ThinEvent';
import { getEventLecturesCount, getEventSpeakersCount } from '@/utils/eventHelpers';

interface IHubsEventCardProps {
  event: ThinEvent;
  hubId: string;
}
export const HubsEventCard = forwardRef<IHubsEventCardProps, typeof EventCard>(function PastEventCard(props, ref) {
  const { event, hubId, ...rest } = props;
  const { t } = useTranslation();

  const { data: counters } = useResources(queryEventHubCounters([event.id], hubId));
  const thisCounter = counters?.[0];

  const lectureCount = thisCounter?.lecturesCount ?? getEventLecturesCount(event);
  const speakerCount = thisCounter?.speakersCount ?? getEventSpeakersCount(event);

  return (
    <EventCard
      ref={ref}
      event={event}
      footer={
        <Flex flexWrap="wrap" mt="14" mx="-2">
          <Text as="p" flex="1" px="2" fontSize="md" lineHeight="base">
            <Heading as="span" mr="2" fontSize={['xl', null, '2xl']} lineHeight="shorter">
              {lectureCount}
            </Heading>
            {t('common.lecture', { count: lectureCount })}
          </Text>
          <Text as="p" flex="1" px="2" fontSize="md" lineHeight="base">
            <Heading as="span" mr="2" fontSize={['xl', null, '2xl']} lineHeight="shorter">
              {speakerCount}
            </Heading>
            {t('common.speaker', { count: speakerCount })}
          </Text>
        </Flex>
      }
      {...rest}
    />
  );
});
